import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BrandingConfigService {
    brandingConfig
    constructor(private http: HttpClient) { }

    loadBrandingConfig(): Promise<any> {
        return this.http.get<any>('assets/brandingConfig.json').toPromise()
            .then(config => {
                this.brandingConfig = config;
            });
    }

    getBrandingConfig(brandId: string): any {
        if (this.brandingConfig && this.brandingConfig[brandId]) {
            return this.brandingConfig[brandId];
        }
        return null;
    }
}
export function initializeBranding(brandingService: BrandingConfigService) {
    return () => brandingService.loadBrandingConfig();
}